import { BaseModel } from "@blue-chip/core";

export default class ProjectForecast extends BaseModel {}
